import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  services: [],
  selectedServices: []
};
const serviceSlice = createSlice({
  name: 'serviceSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setServices(state, action) {
      state.services = action.payload;
    },
    //set selected service by doctor (inside createAndViewServices)
    setSelectedService(state, action) {
      state.selectedServices = action.payload;
    },
    addQuantityInSelectedServiceList(state, action) {
      // Extract the serviceId and any other updates from action.payload
      const { serviceId } = action.payload;
      // Find the index of the service to update
      const serviceIndex = state.selectedServices.findIndex(
        (service) => service.serviceId === serviceId
      );
      if (serviceIndex !== -1) {
        // Update the service immutably
        state.selectedServices[serviceIndex].quantity++;
      } else {
        state.selectedServices = [
          ...state.selectedServices,
          { ...state?.services?.find((ele) => ele?.serviceId == serviceId), quantity: 1 }
        ];
      }
    },
    decrementQuantityInSelectedServiceList(state, action) {
      const serviceId = action.payload;

      // Update the serviceList
      state.selectedServices = state.selectedServices.map((item) =>
        item.serviceId === serviceId && item.quantity > 0
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    },
    zeroQuantityInSelectedServiceList(state, action) {
      const serviceId = action.payload;
      // Update the serviceList
      state.selectedServices = state.selectedServices.map((item) =>
        item.serviceId === serviceId ? { ...item, quantity: 0 } : item
      );
    }
  }
});
export const {
  setSelectedService,
  setServices,
  addQuantityInSelectedServiceList,
  decrementQuantityInSelectedServiceList,
  zeroQuantityInSelectedServiceList
} = serviceSlice.actions;
export default serviceSlice.reducer;
